module.exports = __webpack_public_path__ + "media/images/recruitment/products/product-1-f8b7bbf99de3f1279d98b557387e1a05.jpg";